// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","964":"product"}[chunkId] + "." + {"594":"173f9f23","964":"3ff3f6f4"}[chunkId] + ".js";
};